import { createElement as h, useEffect, useState } from 'react';
import ManoeuvresPanel from './ManoeuvresPanel';

export function topicReading(topic) {
  return [topic.summary, topic.why_it_matters,
    topic.what_good_looks_like?.length ? `What good looks like\n${topic.what_good_looks_like.join('\n')}` : '',
    topic.common_mistakes?.length ? `Common mistakes\n${topic.common_mistakes.join('\n')}` : '',
    topic.self_check?.length ? `Check your understanding\n${topic.self_check.join('\n')}` : '',
  ].filter(Boolean).join('\n\n');
}

// Read-only library access. Rotation does not remount this lesson-scoped panel.
export default function LiveManoeuvres({ read, onResume, onAsk }) {
  const [skills, setSkills] = useState([]);
  const [selected, setSelected] = useState('');
  const [catalogueError, setCatalogueError] = useState('');
  const [detailError, setDetailError] = useState('');
  const [loading, setLoading] = useState(true);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true;
    setLoading(true); setCatalogueError('');
    read('/api/learning-hub-v1/topics').then(data => {
      if (!Array.isArray(data?.topics)) throw new Error('Invalid topic catalogue');
      if (current) setSkills(data.topics.filter(t => t.slug && t.title).map(t => ({ id: t.slug, label: t.title, text: t.summary })));
    }).catch(() => { if (current) setCatalogueError('The learning library could not be loaded. Try again.'); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [read, attempt]);
  useEffect(() => {
    if (!selected) return undefined;
    let current = true;
    setDetailError('');
    read(`/api/learning-hub-v1/topics/${encodeURIComponent(selected)}`).then(topic => {
      if (topic?.slug !== selected) throw new Error('Wrong learning topic');
      if (current) setSkills(items => items.map(item => item.id === selected ? { ...item, text: topicReading(topic) } : item));
    }).catch(() => { if (current) setDetailError('The full explanation could not be loaded. The topic summary is shown. Try again.'); });
    return () => { current = false; };
  }, [read, selected, attempt]);
  return h(ManoeuvresPanel, { skills, onResume, onAsk, onSelect: setSelected,
    libraryStatus: loading ? 'Loading driving skills…' : catalogueError || detailError,
    onRetry: catalogueError || detailError ? () => setAttempt(n => n + 1) : null,
  });
}
